import { Circle, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';

// AIDEV-NOTE: Marcador azul pulsante para posicao do usuario com circulo de precisao

const userIcon = L.divIcon({
  html: `<div style="width:16px;height:16px;background:#1976d2;border:3px solid white;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,0.3)"></div>`,
  iconSize: [16, 16],
  iconAnchor: [8, 8],
  className: ''
});

interface Props {
  lat: number;
  lng: number;
  accuracy: number;
}

export function UserLocationMarker({ lat, lng, accuracy }: Props) {
  return (
    <>
      <Marker position={[lat, lng]} icon={userIcon}>
        <Popup>
          Voce esta aqui
          <br />
          Precisao: ~{Math.round(accuracy)}m
        </Popup>
      </Marker>
      <Circle
        center={[lat, lng]}
        radius={accuracy}
        pathOptions={{
          color: '#1976d2',
          fillColor: '#1976d2',
          fillOpacity: 0.1,
          weight: 1
        }}
      />
    </>
  );
}
